import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=dd927a4c&scoped=true"
import script from "./sys.vue?vue&type=script&lang=js"
export * from "./sys.vue?vue&type=script&lang=js"
import style0 from "./sys.vue?vue&type=style&index=0&id=dd927a4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd927a4c",
  null
  
)

export default component.exports